import grey from '@material-ui/core/colors/grey'
import Tooltip from '@material-ui/core/Tooltip'
import RefreshIcon from '@material-ui/icons/Cached'
import ConfirmDialog from 'lib/ui/ConfirmDialog'
import IconButton from 'lib/ui/IconButton'
import React from 'react'
import styled from 'styled-components'

type Props = {
  disabled?: boolean
  onRefresh: () => void
  label: string
}

export default function RefreshRegistrationTokenButton(props: Props) {
  const {disabled, onRefresh, label} = props

  return (
    <ConfirmDialog
      description={
        <>
          This will generate a new direct access link for this {label}. Anyone
          using the previous link will no longer be able to register.
        </>
      }
      onConfirm={onRefresh}
      confirmLabel="Refresh link"
      variant="dangerous"
    >
      {(confirm) => (
        <Tooltip title="Refresh direct access link" placement="bottom">
          <span>
            <StyledIconButton
              aria-label="refresh direct access link"
              onClick={confirm}
              disabled={disabled}
            >
              <RefreshIcon />
            </StyledIconButton>
          </span>
        </Tooltip>
      )}
    </ConfirmDialog>
  )
}

const StyledIconButton = styled(IconButton)`
  color: ${grey[500]};
  margin-left: ${(props) => props.theme.spacing[1]};
`
